import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Row, Col, Tooltip, } from 'reactstrap';
import { defaultPageSize, EMPTY_DATA, CBCTypeId, EXCHNAGERATE } from '../../../../config/constants';
import NoContentFound from '../../../common/NoContentFound';
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, loggedInUserId, searchNocontentFilter, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide } from '../../../../helper';
// import { runVerifyCombinedProcessSimulation } from '../../actions/Simulation';
import { Fragment } from 'react';
import { Controller, useForm } from 'react-hook-form'
import RunSimulationDrawer from '../RunSimulationDrawer';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import debounce from 'lodash.debounce';
import { TextFieldHookForm } from '../../../layout/HookFormInputs';
import { runVerifyMachineRateSimulation } from '../../actions/Simulation';
import VerifySimulation from '../VerifySimulation';
import Toaster from '../../../common/Toaster';
import { PaginationWrapper } from '../../../common/commonPagination';
import DayTime from '../../../common/DayTimeWrapper';
import WarningMessage from '../../../common/WarningMessage';
import DatePicker from "react-datepicker";
import { useRef } from 'react';
import { getMaxDate } from '../../SimulationUtils';
import ReactExport from 'react-export-excel';
import { MACHINE_IMPACT_DOWNLOAD_EXCEl } from '../../../../config/masterData';
import { simulationContext } from '..';
import LoaderCustom from '../../../common/LoaderCustom';
import { useLabels } from '../../../../helper/core';
import { createMultipleExchangeRate } from '../../../masters/actions/ExchangeRateMaster';
import { parsedDate } from '../../../common/CommonFunctions';
import { beforeSaveCell as validateRevisedRate, validateAndFormatValue, resetFieldToLastValidValue, valueSetter } from '../../../../helper/simulationValidation';
import PriceComparisonSpan from '../../../common/PriceComparisonSpan';
import { useSimulationGrid, useSimulationUndo, useSimulationVBC, useSimulationConfig, useSimulationCalculations } from '../../../../hooks/simulation';
import UndoButton from '../common/UndoButton';
import RedoButton from '../common/RedoButton';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const gridOptions = {

};
function MRSimulation(props) {
    const { showEditMaster, handleEditMasterPage, showCompressedColumns, render } = useContext(simulationContext) || {};
    const { list, isbulkUpload, rowCount, isImpactedMaster, tokenForMultiSimulation, costingAndPartNo } = props
    const [showRunSimulationDrawer, setShowRunSimulationDrawer] = useState(false)
    const [showverifyPage, setShowVerifyPage] = useState(false)
    const [token, setToken] = useState('')
    const [gridApi, setGridApi] = useState(null);
    const [effectiveDate, setEffectiveDate] = useState('');
    const [isEffectiveDateSelected, setIsEffectiveDateSelected] = useState(false);
    const [isWarningMessageShow, setIsWarningMessageShow] = useState(false);
    const [maxDate, setMaxDate] = useState('');
    const [isDisable, setIsDisable] = useState(false)
    const [isEditing, setIsEditing] = useState(false)
    const [hasChanges, setHasChanges] = useState(false)
    const isLoader = false; // Using 'render' from context instead for loading state
    const [noData, setNoData] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false)
    const [basicRateviewTooltip, setBasicRateViewTooltip] = useState(false)
    const [textFilterSearch, setTextFilterSearch] = useState('')
    const gridRef = useRef();
    const { vendorLabel } = useLabels()
    const { technologyLabel } = useLabels();
    const { register, control, setValue, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })

    const dispatch = useDispatch()

    const { selectedMasterForSimulation, selectedTechnologyForSimulation, exchangeRateListBeforeDraft } = useSelector(state => state.simulation)
    const currencySelectList = useSelector(state => state.comman.currencySelectList)
    const masterList = useSelector(state => state.simulation.masterSelectListSimulation)

    // ========================================================================
    // COMMON HOOKS - Using centralized simulation hooks
    // ========================================================================

    // CRITICAL: Define getRowId function ONCE and use it in both hooks
    const getRowId = useCallback((row) => row.MachineProcessRateId || row.MachineId, []);

    // Grid operations hook - replaces gridApi state with common implementation
    const {
        gridApi: hookGridApi,
        onGridReady: commonOnGridReady,
        findNodeByRowId
    } = useSimulationGrid({
        defaultPageSize,
        getRowId  // Pass the same getRowId to grid hook
    });

    // Undo/Redo hook - handles undo/redo functionality with keyboard shortcuts
    const {
        saveUndoState,
        handleUndo: originalHandleUndo,
        handleRedo,
        undoCount,
        redoCount,
        canUndo,
        canRedo
    } = useSimulationUndo({
        gridApi: hookGridApi || gridApi,
        findNodeByRowId,
        disabled: isImpactedMaster,
        getRowId,  // Use the same getRowId function
        enableKeyboardShortcuts: true,
        updateListData: (rowId, restoredData) => {
            // Find and update the item in the list array
            const itemIndex = list.findIndex(item => getRowId(item) === rowId);

            if (itemIndex !== -1) {
                // Update all properties from restoredData
                Object.keys(restoredData).forEach(key => {
                    list[itemIndex][key] = restoredData[key];
                });
            }
        }
    });


    // VBC hook - handles VBC/ZBC/CBC costing type detection
    const {
        isZBCRow, // eslint-disable-line no-unused-vars
        isVBCRow, // eslint-disable-line no-unused-vars
        isCBCRow, // eslint-disable-line no-unused-vars
        getRowCostingType, // eslint-disable-line no-unused-vars
        isRowVBC, // eslint-disable-line no-unused-vars
        shouldShowConditionCostColumn // eslint-disable-line no-unused-vars
    } = useSimulationVBC({
        list,
        ZBCTypeId: null,  // Machine Rate doesn't use ZBC
        VBCTypeId: list?.[0]?.CostingHead === 'Vendor Based' ? list?.[0]?.CostingTypeId : null,
        CBCTypeId: CBCTypeId
    });

    // Config hook - handles configuration and decimal formatting
    const {
        decimalPlaces, // eslint-disable-line no-unused-vars
        formatNumber, // eslint-disable-line no-unused-vars
        isVisible, // eslint-disable-line no-unused-vars
        config // eslint-disable-line no-unused-vars
    } = useSimulationConfig('NoOfDecimalForPrice');

    // Calculations hook - common calculation helpers
    const {
        checkNull, // eslint-disable-line no-unused-vars
        calculateNetLandedCost, // eslint-disable-line no-unused-vars
        calculateBasicPrice, // eslint-disable-line no-unused-vars
        calculatePercentageChange, // eslint-disable-line no-unused-vars
        applyPercentageToBase // eslint-disable-line no-unused-vars
    } = useSimulationCalculations();

    const columnWidths = {
        Technology: showCompressedColumns ? 50 : 190,
        CostingNumber: showCompressedColumns ? 100 : 190,
        PartNo: showCompressedColumns ? 100 : 190,
        MachineName: showCompressedColumns ? 100 : 190,
        MachineNumber: showCompressedColumns ? 100 : 190,
        VendorName: showCompressedColumns ? 100 : 190,
        CustomerName: showCompressedColumns ? 100 : 190,
        ProcessName: showCompressedColumns ? 100 : 190,
        ProcessNumber: showCompressedColumns ? 100 : 190,
        Plant: showCompressedColumns ? 100 : 190,
        EffectiveDate: showCompressedColumns ? 90 : 190,
        LocalCurrency: showCompressedColumns ? 100 : 190,
        NetLandedCost: showCompressedColumns ? 100 : 190,
        NewNetLandedCost: showCompressedColumns ? 100 : 190,
    };
    const cancelVerifyPage = () => {
        setShowVerifyPage(false)
    }

    const effectiveDateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell != null ? <span title={DayTime(cell).format('DD/MM/YYYY')}> {cell.includes("T") ? DayTime(cell).format('DD/MM/YYYY') : cell}</span> : '';
    }

    // Separate useEffect to handle bulk upload count updates when isbulkUpload changes
    useEffect(() => {
        if (isbulkUpload && rowCount) {
            setValue('NoOfCorrectRow', rowCount.correctRow)
            setValue('NoOfRowsWithoutChange', rowCount.NoOfRowsWithoutChange)
        }
    }, [isbulkUpload, rowCount])
    useEffect(() => {

        if (handleEditMasterPage) {
            handleEditMasterPage(showEditMaster, showverifyPage)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showverifyPage])
    useEffect(() => {
        if (list && list.length > 0) {
            window.screen.width >= 1920 && gridRef.current.api.sizeColumnsToFit();
            if (isImpactedMaster) {
                gridRef.current.api.sizeColumnsToFit();
            }
            let maxDate = getMaxDate(list)
            setMaxDate(parsedDate(maxDate?.EffectiveDate));
            // Check for initial changes
            checkForChanges();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list])

    const oldRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)
        return (
            <>
                {
                    isImpactedMaster ?
                        Number(row.OldMachineRate) : cell && value ? Number(cell) : Number(row.MachineRate)
                }

            </>
        )
    }

    const newRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const value = beforeSaveCell(cell)

        if (isImpactedMaster) {
            return row.NewMachineRate;
        }

        const newValue = cell && value ? cell : row.MachineRate;
        const oldValue = row.MachineRate;
        const displayValue = checkForDecimalAndNull(newValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6);

        // Use row ID instead of visual rowIndex
        const rowId = row.MachineProcessRateId || row.MachineId;

        return (
            <PriceComparisonSpan
                newValue={newValue}
                oldValue={oldValue}
                costingTypeId={row?.CostingTypeId}
                className="form-control netCost_revised"
                id={`newRateMachineRate-${rowId}`}
                title={displayValue}
            >
                {displayValue}
            </PriceComparisonSpan>
        )
    }
    const statusFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return <div className={cell}>{row.DisplayStatus}</div>
    }

    const costFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        if (!row.NewBasicRate || row.BasicRate === row.NewBasicRate || row.NewBasicRate === '') return checkForDecimalAndNull(cell, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
        const tempA = Number(row.NewBasicRate) + checkForNull(row.RMFreightCost) + checkForNull(row.RMShearingCost);
        const classGreen = (tempA > row.NetLandedCost) ? 'red-value form-control' : (tempA < row.NetLandedCost) ? 'green-value form-control' : 'form-class'
        return cell != null ? <span className={classGreen}>{checkForDecimalAndNull(cell, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}</span> : ''
    }
    const revisedBasicRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text basicRate_revised'>Revised{!isImpactedMaster && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"basicRate-tooltip"}></i>} </span>
            </div>
        );
    };
    const onFloatingFilterChanged = (value) => {
        // Bug #6 Fix: Removed 500ms setTimeout delay for immediate filter response
        if (list.length !== 0) {
            setNoData(searchNocontentFilter(value, noData))
        }
    }
    /**
  * @method beforeSaveCell
  * @description CHECK FOR ENTER NUMBER IN CELL using common validation
  */
    const beforeSaveCell = (cellValue, props, type) => {
        return validateRevisedRate(cellValue, props, type || 'machineRate');
    }


    const cancel = () => {
        list && list.map((item) => {
            item.NewMachineRate = undefined
            return null
        })
        props.backToSimulation()
    }

    const closeDrawer = (e = '') => {
        setShowRunSimulationDrawer(false)

    }

    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false
    };

    const onGridReady = (params) => {
        // Use common hook's onGridReady for pagination restoration
        commonOnGridReady(params);

        // Set grid API for undo/redo functionality
        setGridApi(params.api);

        // Size columns to fit based on screen width
        window.screen.width >= 1920 && params.api.sizeColumnsToFit();
        if (isImpactedMaster) {
            params.api.sizeColumnsToFit();
        }
    };

    const onPageSizeChanged = (newPageSize) => {
        gridApi?.paginationSetPageSize(Number(newPageSize));
    };

    const onFilterTextBoxChanged = (e) => {
        gridApi?.setQuickFilter(e.target.value);
        setTextFilterSearch(e?.target?.value)
    }

    const resetState = () => {
        setTextFilterSearch('')
        gridApi?.setQuickFilter('');
        gridOptions?.columnApi?.resetColumnState();
        gridOptions?.api?.setFilterModel(null);
        window.screen.width >= 1600 && gridRef.current.api.sizeColumnsToFit();
    }

    const NewcostFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        if (!row.NewMachineRate || Number(row.ConversionCost) === Number(row.NewMachineRate) || row.NewMachineRate === '') return ''

        const NewMachineRate = preciseAdd(Number(row.NewMachineRate), checkForNull(row.RemainingTotal))
        const NetCost = preciseAdd(Number(row.ConversionCost), checkForNull(row.RemainingTotal))
        const displayValue = checkForDecimalAndNull(NewMachineRate, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6);

        return row.NewMachineRate != null ?
            <div className='ag-header-cell-label'>
                <PriceComparisonSpan
                    newValue={NewMachineRate}
                    oldValue={NetCost}
                    costingTypeId={row?.CostingTypeId}
                    title={displayValue}
                >
                    {displayValue}
                </PriceComparisonSpan>
            </div> : ''
    }

    const OldcostFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const ConversionCost = preciseAdd(Number(row.ConversionCost), checkForNull(row.RemainingTotal))
        return row.ConversionCost != null ? checkForDecimalAndNull(ConversionCost, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) : ''
    }

    const customerFormatter = (props) => {
        const row = props?.valueFormatted || props?.data;
        return row ? (isbulkUpload ? row['Customer (Code)'] : row.CustomerName) || '-' : '-';
    }

    // TRIGGER ON EVERY CHNAGE IN CELL
    // Function to check if there are any changes in machine rates
    const checkForChanges = useCallback(() => {
        let changesCount = 0;
        list && list.forEach((item) => {
            if (Number(item.MachineRate) !== Number(item.NewMachineRate) && item?.NewMachineRate !== undefined) {
                changesCount++;
            }
        });
        setHasChanges(changesCount > 0);
    }, [list]);

    // Custom valueSetter to capture old value BEFORE AG Grid updates the node
    const machineRateValueSetter = useCallback((params) => {
        const { newValue, data, node } = params;

        // Save old row data BEFORE AG Grid updates it
        const oldRowData = JSON.parse(JSON.stringify(data));

        // Use the validation-enabled value setter from helper
        const result = valueSetter(params, 'machineRate');

        // After validation passes, save undo state with the old data
        if (result && oldRowData) {
            saveUndoState(oldRowData, 'Edit Machine Rate');
        }

        return result;
    }, [saveUndoState]);

    const onCellValueChanged = (props) => {
        const rowData = props?.data;

        // Update the list array to match the grid node
        if (typeof (checkForNull(props?.value)) === 'number') {
            const editedMachineProcessRateId = props?.data?.MachineProcessRateId;
            const itemIndex = list.findIndex(item => item?.MachineProcessRateId === editedMachineProcessRateId);

            if (itemIndex !== -1) {
                list[itemIndex].NewMachineRate = props?.value;
            }
        }

        // Check for changes after updating the values
        checkForChanges();
        gridApi?.redrawRows()
    }

    const vendorFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {isbulkUpload ? row['Vendor (Code)'] : cell}

            </>
        )
    }
    // Wrap handleUndo to add extra logging and grid refresh
    const handleUndo = useCallback(() => {
        originalHandleUndo();

        checkForChanges();

        if (gridApi) {
            gridApi.redrawRows();
        }
    }, [originalHandleUndo, gridApi, checkForChanges]);
    const plantFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {isbulkUpload ? row['Plant (Code)'] : cell}

            </>
        )
    }
    const localConversionFormatter = (props) => {
        const cellValue = checkForNull(props?.value);
        return checkForDecimalAndNull(cellValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
    }
    const handleEffectiveDateChange = (date) => {
        setEffectiveDate(date)
        setIsEffectiveDateSelected(true)
        setIsWarningMessageShow(false)
    }
    const hyphenFormatter = (props) => {
        const cellValue = props?.value;
        return (cellValue !== ' ' && cellValue !== null && cellValue !== '' && cellValue !== undefined) ? cellValue : '-';
    }
    const frameworkComponents = {
        effectiveDateRenderer: effectiveDateFormatter,
        costFormatter: costFormatter,
        customNoRowsOverlay: NoContentFound,
        newRateFormatter: newRateFormatter,
        oldRateFormatter: oldRateFormatter,
        statusFormatter: statusFormatter,
        NewcostFormatter: NewcostFormatter,
        OldcostFormatter: OldcostFormatter,
        onCellValueChanged: onCellValueChanged,
        vendorFormatter: vendorFormatter,
        plantFormatter: plantFormatter,
        customerFormatter: customerFormatter,
        revisedBasicRateHeader: revisedBasicRateHeader,
        localConversionFormatter: localConversionFormatter,
        hyphenFormatter: hyphenFormatter,
        nullHandler: props.nullHandler && props.nullHandler
    };
    const verifySimulation = debounce(() => {
        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            dispatch(createMultipleExchangeRate(exchangeRateListBeforeDraft, currencySelectList, effectiveDate, res => {
                if (!res?.status && !res?.error) {
                    setValueFunction(true, res);
                }
            }))
        } else {
            setValueFunction(false, []);
        }

    }, 500);
    const setValueFunction = (isExchangeRate, res) => {
        const filteredMasterId = masterList?.find(item => item?.Text === 'Machine Rate')?.Value;
        if (!isEffectiveDateSelected) {
            setIsWarningMessageShow(true)
            return false
        }

        let ccCount = 0
        let tempData = list
        let arr = []
        tempData && tempData.map((li, index) => {
            if (Number(li.MachineRate) === Number(li.NewMachineRate) || li?.NewMachineRate === undefined) {
                ccCount = ccCount + 1
            } else {

                li.NewTotal = preciseAdd(Number(li.NewMachineRate ? li.NewMachineRate : li.MachineRate), checkForNull(li.RemainingTotal))

                arr.push(li)
            }
            return null;
        })
        if (ccCount === tempData.length) {
            Toaster.warning('Please change the machine rate, then run simulation')
            return false
        }
        setIsDisable(true)
        let obj = {}
        obj.SimulationTechnologyId = isExchangeRate ? EXCHNAGERATE : selectedMasterForSimulation.value
        obj.LoggedInUserId = loggedInUserId()
        obj.SimulationHeadId = list[0].CostingTypeId
        obj.TechnologyId = selectedTechnologyForSimulation.value
        obj.TechnologyName = selectedTechnologyForSimulation.label
        obj.EffectiveDate = DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss')
        obj.ExchangeRateSimulationTechnologyId = filteredMasterId

        let tempArr = []
        arr && arr.map(item => {
            let tempObj = {}
            tempObj.MachineId = item.MachineId
            tempObj.MachineProcessRateId = item.MachineProcessRateId
            tempObj.OldMachineRate = item.MachineRate
            tempObj.NewMachineRate = item.NewMachineRate
            tempArr.push(tempObj)
            return null
        })

        obj.SimulationIds = tokenForMultiSimulation

        obj.SimulationMachineProcessList = tempArr
        if (isExchangeRate) {
            obj.SimulationExchangeRates = res
            obj.IsExchangeRateSimulation = true
        }
        dispatch(runVerifyMachineRateSimulation(obj, res => {
            setIsDisable(false)
            if (res?.data?.Result) {
                setToken(res.data.Identity)
                setShowVerifyPage(true)
            }
        }))
        setShowTooltip(false)

    }

    const basicRatetooltipToggle = () => {
        setBasicRateViewTooltip(!basicRateviewTooltip)
    }

    const onBtExport = () => {
        return returnExcelColumn(MACHINE_IMPACT_DOWNLOAD_EXCEl, list)
    };

    const returnExcelColumn = (data = [], TempData) => {

        let temp = []
        TempData && TempData.forEach((item) => {
            let newItem = { ...item }
            newItem.EffectiveDate = (newItem.EffectiveDate)?.slice(0, 10)
            newItem.NewMachineRate = newItem?.NewMachineRate ? newItem?.NewMachineRate : newItem?.MachineRate
            newItem.MachineRate = isImpactedMaster ? newItem?.OldMachineRate : newItem?.MachineRate

            Object.keys(newItem).forEach(key => {
                if (newItem[key] === null || newItem[key] === undefined || newItem[key] === '') {
                    newItem[key] = "-"
                }
            })

            temp.push(newItem)
        })

        if (isImpactedMaster) {
            data = data.filter(column => !['CostingHead', 'Technology', 'Plant', 'VendorName'].includes(column.value));
        } else {
            data = data.filter(column => !['LocalCurrency', 'PreviousMinimum', 'PreviousMaximum', 'PreviousAverage',
                'Minimum', 'Maximum', 'Average', 'NewMachineRateLocalConversion', 'OldMachineRateLocalConversion'].includes(column.value));
        }
        return (
            <ExcelSheet data={temp} name={'Machine Data'}>
                {data && data.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
            </ExcelSheet>);
    }

    return (
        <div>
            <div className={`ag-grid-react`}>
                {!showverifyPage &&
                    <Fragment>
                        {!isImpactedMaster && showTooltip && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={basicRateviewTooltip} toggle={basicRatetooltipToggle} target={"basicRate-tooltip"} >{"To edit revised net machine rate please double click on the field."}</Tooltip>}
                        <div>

                            <Row>
                                <Col className={`add-min-height mb-3 sm-edit-page  ${(list && list?.length <= 0) || noData ? "overlay-contain" : ""}`}>
                                    <div className="ag-grid-wrapper height-width-wrapper">
                                        <div className="ag-grid-header d-flex align-items-center justify-content-between">
                                            <div className='d-flex align-items-center'>
                                                <input type="text" className="form-control table-search" id="filter-text-box" value={textFilterSearch} placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                                <button type="button" className="user-btn float-right mr-2 Tour_List_Reset Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                                                    <div className="refresh mr-0"></div>
                                                </button>
                                                <ExcelFile filename={`${props.lastRevision ? 'Last Revision Data' : 'Impacted Master Data'}`} fileExtension={'.xls'} element={
                                                    <button title="Download" type="button" className={'user-btn'} ><div className="download mr-0"></div></button>}>
                                                    {onBtExport()}
                                                </ExcelFile>
                                            </div>

                                            <div className='d-flex justify-content-end bulk-upload-row pr-0 zindex-2'>
                                                {
                                                    isbulkUpload && <>
                                                        <div className="d-flex align-items-center">
                                                            <label>Rows with changes:</label>
                                                            <TextFieldHookForm
                                                                label=""
                                                                name={'NoOfCorrectRow'}
                                                                Controller={Controller}
                                                                control={control}
                                                                register={register}
                                                                rules={{ required: false }}
                                                                mandatory={false}
                                                                handleChange={() => { }}
                                                                defaultValue={''}
                                                                className=""
                                                                customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                                errors={errors.NoOfCorrectRow}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <label>Rows without changes:</label>
                                                            <TextFieldHookForm
                                                                label=""
                                                                name={'NoOfRowsWithoutChange'}
                                                                Controller={Controller}
                                                                control={control}
                                                                register={register}
                                                                rules={{ required: false }}
                                                                mandatory={false}
                                                                handleChange={() => { }}
                                                                defaultValue={''}
                                                                className=""
                                                                customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                                errors={errors.NoOfRowsWithoutChange}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                {!isImpactedMaster && (
                                                    <>
                                                        <UndoButton
                                                            undoCount={undoCount}
                                                            onUndo={handleUndo}
                                                            disabled={isImpactedMaster || !canUndo}
                                                            position="right"
                                                        />
                                                        <RedoButton
                                                            redoCount={redoCount}
                                                            onRedo={handleRedo}
                                                            disabled={isImpactedMaster || !canRedo}
                                                            position="right"
                                                        />
                                                    </>
                                                )}
                                                {
                                                    !isImpactedMaster && list && <div className={`d-flex align-items-center simulation-label-container`}>
                                                        <div className='d-flex pl-3'>
                                                            <label>{technologyLabel}: </label>
                                                            <p className='technology ml-1' title={list[0].Technology}>{list[0].Technology}</p>
                                                        </div>
                                                        {list[0].CostingHead === 'Vendor Based' && list[0].CostingTypeId !== CBCTypeId && <div className='d-flex pl-3'>
                                                            <label className='mr-1'>{vendorLabel} (Code):</label>
                                                            <p className='mr-2' title={list[0].VendorName}>{list[0].VendorName ? list[0].VendorName : list[0][`${vendorLabel} (Code)`]}</p>
                                                        </div>}
                                                        <button type="button" id="simulation-back" className={"apply back_simulationPage"} onClick={cancel}> <div className={'back-icon'}></div>Back</button>
                                                    </div>}
                                            </div>
                                        </div>


                                        <div className="ag-theme-material p-relative" style={{ width: '100%' }}>
                                            {(render || isLoader) && <LoaderCustom customClass="loader-center" />}
                                            {!(render || isLoader) && (!list || list.length === 0) && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found simulation-lisitng" />}
                                            {!(render || isLoader) && list && list.length > 0 && <AgGridReact
                                                ref={gridRef}
                                                floatingFilter={true}
                                                style={{ height: '100%', width: '100%' }}
                                                defaultColDef={defaultColDef}
                                                domLayout='autoHeight'
                                                // columnDefs={c}
                                                rowData={list}
                                                pagination={true}
                                                paginationPageSize={defaultPageSize}
                                                onGridReady={onGridReady}
                                                gridOptions={gridOptions}
                                                // loadingOverlayComponent={'customLoadingOverlay'}
                                                noRowsOverlayComponent={'customNoRowsOverlay'}
                                                onFilterModified={onFloatingFilterChanged}
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                }}
                                                frameworkComponents={frameworkComponents}
                                                stopEditingWhenCellsLoseFocus={true}
                                                suppressColumnVirtualisation={true}
                                                rowSelection={'multiple'}
                                                onCellValueChanged={onCellValueChanged}
                                                onCellEditingStarted={() => setIsEditing(true)}
                                                onCellEditingStopped={() => setIsEditing(false)}
                                                enableBrowserTooltips={true}
                                            >
                                                {!isImpactedMaster && <AgGridColumn minWidth={columnWidths?.CostingNumber} field="CostingHead" tooltipField='CostingHead' headerName="Costing Head" editable='false' cellRenderer={'costingHeadFormatter'}></AgGridColumn>}
                                                {!isImpactedMaster && <AgGridColumn field="Technology" tooltipField='Technology' editable='false' headerName={technologyLabel} minWidth={columnWidths?.Technology}></AgGridColumn>}
                                                {costingAndPartNo && <AgGridColumn field="CostingNumber" tooltipField='CostingNumber' editable='false' headerName="Costing No" minWidth={columnWidths?.CostingNumber}></AgGridColumn>}
                                                {costingAndPartNo && <AgGridColumn field="PartNo" tooltipField='PartNo' editable='false' headerName="Part No" minWidth={columnWidths?.PartNo}></AgGridColumn>}
                                                {/* props?.isImpactedMaster&& */<AgGridColumn field="EntryType" minWidth={120} headerName="Entry Type" editable='false' cellRenderer={"hyphenFormatter"}></AgGridColumn>}
                                                <AgGridColumn field="MachineName" tooltipField='MachineName' editable='false' headerName="Machine Name" minWidth={columnWidths?.MachineName}></AgGridColumn>
                                                <AgGridColumn field="MachineNumber" tooltipField='MachineNumber' editable='false' headerName="Machine Number" minWidth={columnWidths?.MachineNumber}></AgGridColumn>
                                                <AgGridColumn field="ProcessName" tooltipField='ProcessName' editable='false' headerName="Process Name" minWidth={columnWidths?.ProcessName}></AgGridColumn>
                                                {!isImpactedMaster && list[0].CostingTypeId !== CBCTypeId && <AgGridColumn field="VendorName" tooltipField='VendorName' editable='false' headerName={vendorLabel + " (Code)"} minWidth={columnWidths?.VendorName} cellRenderer='vendorFormatter'></AgGridColumn>}
                                                {!isImpactedMaster && list[0].CostingTypeId === CBCTypeId && <AgGridColumn minWidth={columnWidths?.CustomerName} field="CustomerName" tooltipField='CustomerName' editable='false' headerName="Customer (Code)" cellRenderer='customerFormatter'></AgGridColumn>}
                                                {
                                                    !isImpactedMaster &&
                                                    <>
                                                        <AgGridColumn field="Plant" tooltipField='Plant' editable='false' headerName="Plant (Code)" minWidth={columnWidths?.Plant} cellRenderer='plantFormatter'></AgGridColumn>

                                                    </>
                                                }
                                                {getConfigurationKey().IsSourceExchangeRateNameVisible && <AgGridColumn minWidth={120} field="ExchangeRateSourceName" headerName="Exchange Rate Source" editable='false'></AgGridColumn>}
                                                <AgGridColumn field="Currency" minWidth={180} headerName="Currency/Settlement Currency" cellRenderer={"hyphenFormatter"} editable='false'></AgGridColumn>
                                                {(isImpactedMaster || props?.lastRevision) && <AgGridColumn field="LocalCurrency" minWidth={120} headerName={"Plant Currency"} cellRenderer={"hyphenFormatter"} editable='false'></AgGridColumn>}

                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" headerName="Net Cost (Currency)" marryChildren={true} suppressSizeToFit={true} pinned='right'>
                                                    <AgGridColumn field="MachineRate" tooltipField='MachineRate' editable='false' headerName="Existing" cellRenderer='oldRateFormatter' colId="MachineRate" suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn cellRenderer='newRateFormatter' editable={!isImpactedMaster} field="NewMachineRate" headerName="Revised" colId='NewMachineRate' headerComponent={'revisedBasicRateHeader'} suppressSizeToFit={true} pinned='right' valueSetter={machineRateValueSetter}></AgGridColumn>
                                                </AgGridColumn>
                                                {(isImpactedMaster || props?.lastRevision || String(props?.masterId) === String(EXCHNAGERATE)) && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" headerName={
                                                    "Net Machine Rate (Plant Currency)"} suppressSizeToFit={true} marryChildren={true} pinned='right'>
                                                    <AgGridColumn field="OldMachineRateLocalConversion" editable='false' cellRenderer='localConversionFormatter' headerName="Existing" colId='OldMachineRateLocalConversion' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn field="NewMachineRateLocalConversion" editable='false' cellRenderer='localConversionFormatter' headerName="Revised" colId='NewMachineRateLocalConversion' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                }
                                                {props.children}
                                                <AgGridColumn field="EffectiveDate" headerName={props.isImpactedMaster && !props.lastRevision ? "Current Effective date" : "Effective Date"} editable='false' minWidth={columnWidths?.EffectiveDate} cellRenderer='effectiveDateRenderer'></AgGridColumn>
                                                <AgGridColumn field="CostingId" hide={true}></AgGridColumn>


                                            </AgGridReact >}
                                            {<PaginationWrapper gridApi={gridApi} setPage={onPageSizeChanged} />}
                                        </div>
                                    </div>

                                </Col>
                            </Row>
                            {
                                !isImpactedMaster &&
                                <Row className="sf-btn-footer no-gutters justify-content-between bottom-footer">
                                    <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                                        <div className="inputbox date-section mr-3 verfiy-page simulation_effectiveDate">
                                            <DatePicker
                                                name="EffectiveDate"
                                                id="EffectiveDate"
                                                selected={DayTime(effectiveDate).isValid() ? new Date(effectiveDate) : ''}
                                                onChange={handleEffectiveDateChange}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode='select'
                                                dateFormat="dd/MM/yyyy"
                                                minDate={maxDate}
                                                placeholderText="Select effective date"
                                                className="withBorder"
                                                autoComplete={"off"}
                                                disabledKeyboardNavigation
                                                onChangeRaw={(e) => e.preventDefault()}
                                            />
                                            {isWarningMessageShow && <WarningMessage dClass={"error-message"} textClass={"pt-1"} message={"Please select effective date"} />}
                                        </div>

                                        <button
                                            onClick={verifySimulation}
                                            type="submit"
                                            id="verify-btn"
                                            className="user-btn mr5 save-btn verifySimulation"
                                            disabled={isDisable || isEditing || !hasChanges || !isEffectiveDateSelected}
                                            title={
                                                isDisable ? "Simulation is running..." :
                                                    isEditing ? "Please finish editing the current cell" :
                                                        !isEffectiveDateSelected ? "Please select an effective date" :
                                                            !hasChanges ? "Please make changes to machine rates before verifying" :
                                                                "Click to verify simulation"
                                            }
                                        >
                                            <div className={"Run-icon"}>
                                            </div>{" "}
                                            {"Verify"}
                                        </button>
                                        {/* <button onClick={runSimulation} type="submit" className="user-btn mr5 save-btn"                    >
                                <div className={"Run"}>
                                </div>{" "}
                                {"RUN SIMULATION"}
                            </button> */}
                                    </div>
                                </Row>
                            }
                        </div>
                    </Fragment>

                }
                {
                    showverifyPage &&
                    <VerifySimulation master={selectedMasterForSimulation.value} token={token} cancelVerifyPage={cancelVerifyPage} />
                }

                {
                    showRunSimulationDrawer &&
                    <RunSimulationDrawer
                        isOpen={showRunSimulationDrawer}
                        closeDrawer={closeDrawer}
                        anchor={"right"}
                    // masterId={selectedMasterForSimulation.value}
                    />
                }
            </div>

        </div >
    );
}

export default MRSimulation;